/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingAggregationResponseBatch {
    getFixupPrototypeFunction() { return BillingAggregationResponseBatch.fixupPrototype; }

    static newInstance(model: Partial<BillingAggregationResponseBatch>): BillingAggregationResponseBatch {
        let obj = Object.assign(new BillingAggregationResponseBatch(), model);
        BillingAggregationResponseBatch.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingAggregationResponseBatch>): BillingAggregationResponseBatch {
        if (!model) return null;
        return BillingAggregationResponseBatch.newInstance(<BillingAggregationResponseBatch> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingAggregationResponseBatch) {
        if (!obj) return;

        models.BillingAggregationResponseBatch.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingAggregationResponseBatch): boolean {
        Object.setPrototypeOf(obj, BillingAggregationResponseBatch.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let val of this.results) {
                if (val) {
                    for (let subVal of val) {
                        models.BillingAggregationResult.fixupPrototype(subVal);
                    }
                }
            }
        }
    }

    /**
     * Batch of aggregation requests
     */
    results: Array<Array<models.BillingAggregationResult>>;

}
